import styled from 'styled-components'

export const Wrapper = styled.section`
  padding: 30px;
  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    display: flex;
    align-items: center;
    padding: 120px;
  }
`

export const Column = styled.div`
  margin: 30px 0;

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    margin: 0;
    flex: 1 1 0;
  }
`

export const Title = styled.h3`
  position: relative;

  &:after {
    display: block;
    position: absolute;
    content: '';
    bottom: 0;
    height: 1px;
    width: 160px;
    background-color: #e2b765;
  }
`

export const Logo = styled.img`
  max-width: 80%;
  width: auto;
  height: auto;
  display: block;
  margin: 0 auto;
`
